import {SubscriptionPriceDto} from 'learndb-share'

function getYearEconomy(priceMonth: SubscriptionPriceDto, priceYear: SubscriptionPriceDto): number {
  return 12 * priceMonth.priceDiscount - priceYear.priceDiscount
}

export {getYearEconomy}
